import { render } from "./StatusMappingTab.vue?vue&type=template&id=25a96925&scoped=true"
import script from "./StatusMappingTab.vue?vue&type=script&lang=js"
export * from "./StatusMappingTab.vue?vue&type=script&lang=js"

import "./StatusMappingTab.vue?vue&type=style&index=0&id=25a96925&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a96925"]])

export default __exports__